import { useDispatch, useSelector } from 'react-redux'
import ReportFilters from './filters'
import ReportUserList from './reportUserList'
import { useEffect, useRef } from 'react'
import { getAllUserReportList, resetTableData } from './store/finalReports.slice'

const FinalReports = () => {
    useEffect(() => {
        dispatch(resetTableData())
    }, [])
    const dispatch = useDispatch()
    const tableData = useSelector((state) => state.finalReportsSlice.tableData)

    const isFirstLoad = useRef(true)
    const prevDataRef = useRef(null)

    // useEffect(() => {
    //     if (isFirstLoad.current) {
    //         dispatch(getAllUserReportList({ ...tableData }))
    //         isFirstLoad.current = false
    //         prevDataRef.current = tableData
    //     }
    // }, [tableData, dispatch])
    // useEffect(() => {
    //     if (isFirstLoad.current) {
    //         const cleanedData = {
    //             ...tableData,
    //             projectId: Array.isArray(tableData.projectId) &&
    //                 tableData.projectId.length > 0 &&
    //                 tableData.projectId[0] !== undefined
    //                 ? tableData.projectId
    //                 : undefined, // don't include projectId if empty/null
    //         }
    //         dispatch(getAllUserReportList(cleanedData))
    //         isFirstLoad.current = false
    //         prevDataRef.current = tableData
    //     }
    // }, [tableData, dispatch])



    useEffect(() => {
        const cleanedData = {
            ...tableData,
            projectId: Array.isArray(tableData.projectId) &&
                tableData.projectId.length > 0 &&
                tableData.projectId[0] !== undefined
                ? [tableData.projectId[0]?.value]
                : undefined, // skip empty projectId
        }
        // console.log("🚀 ~ useEffect ~ cleanedData:", cleanedData)
        if (tableData.start || tableData.end) {

            dispatch(getAllUserReportList(cleanedData))
        }

    }, [tableData?.page, tableData?.limit, tableData?.userId, tableData?.dateType, tableData?.end, tableData?.projectId])



    return (
        <div>
            <div
                className="container"
                style={{
                    zIndex: 10,
                    minHeight: '100vh',
                    padding: '35px',
                }}
            >
                <ReportFilters name={"timeSheet"} />
                <ReportUserList />
            </div>
        </div>
    )
}

export default FinalReports
